import { render } from "./InfoReviewBlock.vue?vue&type=template&id=56c9a022"
import script from "./InfoReviewBlock.vue?vue&type=script&lang=ts"
export * from "./InfoReviewBlock.vue?vue&type=script&lang=ts"
script.render = render

export default script